
import _ from 'lodash';
import propTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import notificationPopUp from '../../../../NotificationPopUp';

import checkFunctions from '../../../../CheckFunction';

import AirBnbDateTimePicker from '../../../common/airBnbDatepicker/AirBnbDateTimePicker';
import TextInput from '../../../common/TextInput';

import * as authenticationActions from '../../../../actions/authenticationActions';
import * as commonActions from '../../../../actions/commonActions';
import * as userActions from '../../../../actions/userActions';

class UserBasicPage extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            authenticationState: this.props.authenticationState,
            user: props.user
        };

        if (!authenticationActions.verifyAuthentication(this.state.authenticationState, this.props.history)) {
            return;
        }

        this.saveUser = this.saveUser.bind(this);
        this.updateState = this.updateState.bind(this);
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        if (this.state.user.id > -1) {
            this.props.userActions.loadBasicUser(this.state.user.id).then((user) => {
                this.setState(Object.assign({}, this.state, { user: user }));
            }).catch(error => {
                notificationPopUp.error(error);
            });
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.authenticationState !== prevState.authenticationState)
            return Object.assign({}, prevState, { authenticationState: nextProps.authenticationState });
        return null;
    }

    saveUser(event) {
        if (this.validate()) {
            this.props.userActions.saveBasicUser(this.state.user).then((newUser) => {
                this.setState(Object.assign({}, this.state, { user: newUser }));
                notificationPopUp.success('Dati salvati con successo');
            }).catch(error => {
                notificationPopUp.error(error);
            });
        } else {
            notificationPopUp.warning('Utente non valido');
        }
    }

    updateState(event) {
        const state = Object.assign({}, this.state);
        state.user[event.target.name] = event.target.value;
        this.setState(Object.assign({}, this.state, state));
    }

    validate() {
        const appV = (!_.isNil(this.state.user.emailAddress) && !_.isEmpty(_.trim(this.state.user.emailAddress))) &&
            (checkFunctions.checkEmail(this.state.user.emailAddress)) &&
            (!_.isNil(this.state.user.workPhone) && !_.isEmpty(_.trim(this.state.user.workPhone)));

        if (!_.isNil(this.state.newPassword) && (!_.isEmpty(this.state.newPassword))) {
            if (_.isNil(this.state.password) || _.isEmpty(this.state.password)) {
                notificationPopUp.warning('Per cambiare la password bisogna inserire la password attuale e la nuova');
                return false;
            }
            if (this.state.newPassword !== this.state.newPasswordConfirm) {
                notificationPopUp.warning('Conferma la nuova password in modo corretto');
                return false;
            }
        }

        return appV;
    }

    render() {
        return (
            <div className="container">
                <h1>{this.state.user.firstName} {this.state.user.lastName}</h1>
                <Row>
                    <Col sm={12}>
                        <button className='btn btn-primary' onClick={() => this.props.history.goBack()} style={{ marginBottom: 10 }} ><span className='glyphicon glyphicon-arrow-left'></span> Indietro</button>
                        <div className="panel panel-default x-panel">
                            <div className="panel-heading">Dettagli Anagrafici</div>
                            <div className="panel-body">
                                <Row>
                                    <Col md={6}>
                                        <TextInput
                                            disabled='disabled'
                                            label="Nome"
                                            name="firstName"
                                            value={this.state.user.firstName} />
                                    </Col>
                                    <Col md={6}>
                                        <TextInput
                                            disabled='disabled'
                                            label="Cognome"
                                            name="lastName"
                                            value={this.state.user.lastName} />
                                    </Col>
                                    <Col md={6}>
                                        <TextInput
                                            disabled='disabled'
                                            label="C.F."
                                            name="taxCode"
                                            onChange={this.updateState}
                                            value={this.state.user.taxCode} />
                                    </Col>
                                    <Col md={6}>
                                        <AirBnbDateTimePicker
                                            disabled={true}
                                            name='birthDate'
                                            label="Data Nascita"
                                            onChange={this.updateState}
                                            value={this.state.user.birthDate} />
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <div className="panel panel-default x-panel-green">
                            <div className="panel-heading">Recapiti</div>
                            <div className="panel-body">
                                <Row>
                                    <Col md={6}>
                                        <TextInput
                                            name="emailAddress"
                                            label="Email"
                                            required={true}
                                            type='email'
                                            value={this.state.user.emailAddress}
                                            onChange={this.updateState} />
                                    </Col>
                                    <Col md={6}>
                                        <TextInput
                                            name="workPhone"
                                            label="Telefono"
                                            required={true}
                                            value={this.state.user.workPhone}
                                            onChange={this.updateState} />
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <div className="panel panel-default x-panel-orange">
                            <div className="panel-heading">Password</div>
                            <div className="panel-body">
                                <Row>
                                    <Col md={6}>
                                        <TextInput
                                            name="password"
                                            label="Password"
                                            type='password'
                                            value={this.state.user.password}
                                            onChange={this.updateState} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <TextInput
                                            name="newPassword"
                                            label="Nuova Password"
                                            type='password'
                                            value={this.state.user.newPassword}
                                            onChange={this.updateState} />
                                    </Col>
                                    <Col md={6}>
                                        <TextInput
                                            name="newPasswordConfirm"
                                            label="Conferma Nuova Password"
                                            type='password'
                                            value={this.state.user.newPasswordConfirm}
                                            onChange={this.updateState} />
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                    <Col md={4} mdOffset={4}>
                        <center><Button bsStyle='primary' bsSize="large" onClick={this.saveUser} ><span className='glyphicon glyphicon-floppy-disk'></span> Salva</Button> </center>
                    </Col>
                </Row >
            </div >
        );
    }
}

UserBasicPage.propTypes = {
    authenticationState: propTypes.object.isRequired
};

UserBasicPage.contextTypes = {
    router: propTypes.object
};

function mapStateToProps(state, ownProps) {
    const user = {
        id: ownProps.match.params.id,
        birthDate: new Date().toISOString(),
        emailAddress: '',
        firstName: '',
        lastName: '',
        newPassword: '',
        newPasswordConfirm: '',
        password: '',
        taxCode: '',
        workPhone: ''
    };

    return {
        authenticationState: state.authenticationState,
        user: user
    };
}

function mapDispatchToProps(dispatch) {
    return {
        authenticationActions: bindActionCreators(authenticationActions, dispatch),
        commonActions: bindActionCreators(commonActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserBasicPage);
